import { Box, Button, Typography } from '@mui/material';
import { AMBER, AMBER_DARK, NAV_BG } from '../theme';

export default function EmptyState({ icon: Icon, message, subtitle, action }) {
    return (
        <Box sx={{ py: 6, textAlign: 'center' }}>
            {Icon && <Icon sx={{ fontSize: 48, color: '#94a3b8', mb: 1 }} />}
            <Typography sx={{ fontFamily: '"Outfit", sans-serif', color: '#94a3b8' }}>
                {message}
            </Typography>
            {subtitle && (
                <Typography sx={{ fontFamily: '"Outfit", sans-serif', fontSize: '0.82rem', color: '#94a3b8', mt: 0.5 }}>
                    {subtitle}
                </Typography>
            )}
            {action && (
                <Button
                    variant="contained"
                    size="small"
                    startIcon={action.icon}
                    onClick={action.onClick}
                    sx={{
                        mt: 2,
                        fontFamily: '"Outfit", sans-serif',
                        textTransform: 'none',
                        fontWeight: 600,
                        borderRadius: '8px',
                        background: `linear-gradient(135deg, ${AMBER} 0%, ${AMBER_DARK} 100%)`,
                        color: NAV_BG,
                        '&:hover': { background: `linear-gradient(135deg, #fbbf24 0%, ${AMBER} 100%)` },
                    }}
                >
                    {action.label}
                </Button>
            )}
        </Box>
    );
}
